import { ContentSectionContainer, fetchRoute } from "@cakemail-org/ui-components-v2"
import { Route, Routes } from "react-router-dom"
import { ABTestsContext } from "./context"
import { ABTestsListing } from "./containers/listing"
import { ERoutes } from "../../utils/url"
import { EABTestsNav } from "./types"

export default function ABTests({}): any {
    return (
        <ContentSectionContainer className="abTestsContainer">
            <ABTestsContext.Provider value={{}}>
                <Routes>
                    <Route index path={fetchRoute({ route: ERoutes.campaignsABTest })} element={<ABTestsListing initTab={EABTestsNav.Draft} />} />
                    <Route path={fetchRoute({ route: ERoutes.campaignABTestActive })} element={<ABTestsListing initTab={EABTestsNav.Active} />} />
                    <Route path={fetchRoute({ route: ERoutes.campaignABTestComplete })} element={<ABTestsListing initTab={EABTestsNav.Completed} />} />

                    <Route index path={"/"} element={<ABTestsListing initTab={EABTestsNav.Draft} />} />
                    <Route index path={"/active"} element={<ABTestsListing initTab={EABTestsNav.Active} />} />
                    <Route index path={"/complete"} element={<ABTestsListing initTab={EABTestsNav.Completed} />} />
                </Routes>
            </ABTestsContext.Provider>
        </ContentSectionContainer>
    )
}